<template>
  <div class="colored-svg" :style="{ '--svgUrl': svgUrl, backgroundColor: color }" />
</template>

<script>
export default {
  name: 'ColoredSvg',
  props: {
    svgSrc: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    svgUrl() {
      return `url(${this.svgSrc})`;
    },
  },
};
</script>

<style scoped lang="scss">
.colored-svg {
  -webkit-mask: var(--svgUrl) no-repeat center;
  mask: var(--svgUrl) no-repeat center;
  mask-size: contain;
  -webkit-mask-size: contain;
}
</style>
